import { useContext } from "react";
import SupportedSocialMediaContext from "./contex";
import { DefaultSupportedSocialMediaValuesContextProps } from "./supported-social-media-context";


export const useSupportedSocialMediaContext = (): DefaultSupportedSocialMediaValuesContextProps => {
  const context = useContext(SupportedSocialMediaContext);
  if (!context) {
    throw new Error('usePathHistory must be used within a PathHistoryProvider');
  }
  return context;
};


